document.addEventListener("DOMContentLoaded", function () {
  //const Klaviyoform = document.querySelector('[data-testid="klaviyo-form-WjZMgn"]');
  let formSearchCount = 0;
  const intervalForKlaviyo = setInterval(() => {
    const svgX = document.querySelector('[xmlns="http://www.w3.org/2000/svg"]');
    const popUpContainer = document.querySelector('[data-testid="POPUP"]'); // Replace with your actual selector
    if (svgX && popUpContainer) {
      clearInterval(intervalForKlaviyo);
      svgX.style.opacity = "0";
      const popUpCloseBtn = document.querySelector(
        '[aria-label="Close dialog"]'
      );
      const imgX = document.createElement("img");
      imgX.src =
        "https://cdn.shopify.com/s/files/1/2536/1982/files/close-removebg-preview.png?v=1686284355";
      imgX.width = "20";
      imgX.height = "20";
      imgX.alt = "Gelato Pique sign up";
      let getStyleProperties = popUpCloseBtn.getAttribute("style");

      getStyleProperties = getStyleProperties.replace(
        "margin-right: 8px;",
        "margin-right: 20px;"
      );
      getStyleProperties = getStyleProperties.replace(
        "margin-top: 8px;",
        "margin-top: 20px;"
      );
      popUpCloseBtn.setAttribute("style", getStyleProperties);
      popUpCloseBtn.appendChild(imgX);
      popUpContainer.classList.add("popUpWidthMod");
      svgX.remove();
    } else {
      formSearchCount++;
      //console.log(formSearchCount);
      if (formSearchCount > 20) {
        //console.log("Element NOT FOUND:", svgX);
        clearInterval(intervalForKlaviyo);
      }
    }
  }, 1000);
});
